import { Model, modelRegistry } from './Model';
import { Shift, User } from '../models';
import ApiService from '../services/ApiService';
import HashGen from '../utilities/HashGen';
import Money from '../utilities/Money';
import Store from '../wrappers/Store';
import { connectionService } from '../services';
export class UserTransaction extends Model {
    static entity = 'user_transactions';
    static primaryKey = 'hash';
    static syncable = true;
    id = null;
    hash = '';
    user_id = null;
    shift_id = null;
    shift_hash = null;
    amount = '0.0000';
    type = null;
    issued_at = null;
    created_at = null;
    updated_at = null;
    shift;
    user;
    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            user_id: this.attr(null),
            shift_id: this.attr(null),
            shift_hash: this.attr(null),
            amount: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            type: this.attr(null),
            issued_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            shift: this.attr(undefined, value => value ? new Shift(value) : undefined),
            user: this.attr(undefined, value => value ? new User(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /**
     * Sync the data with the server
     */
    async sync() {
        await this.markForSync('create');
        this.$save();
        if (!Store.get('isOnline')) {
            return { success: true };
        }
        try {
            const response = await ApiService.post(`/users/${this.user_id}/transactions`, this.$toJson());
            this.$fill(response.data);
            UserTransaction.insert({ data: [response.data] });
            UserTransaction.syncTerminals({ items: [{ action: 'patch', record: response.data }] });
            await this.removeFromSync();
            return { success: true };
        }
        catch (error) {
            const isOnline = await connectionService.connectionCheckRetry(5000);
            return { success: isOnline };
        }
    }
    getAmount() {
        return Money.parse(this.amount);
    }
}
export default UserTransaction;
modelRegistry.register('UserTransaction', UserTransaction);
//# sourceMappingURL=UserTransaction.js.map